import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';

const XAUUSDPnLCalendar = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [pnlData, setPnlData] = useState({});
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const currentYear = 2025;

    // CSV data embedded as a string
    const csvData = `date,daily_pnl,cumulative_pnl
2025-04-01,-1267.7000000000735,9991.699999999217
2025-04-02,449.04999999986285,10440.74999999908
2025-04-03,5302.850000000008,15743.599999999087
2025-04-04,891.9499999999316,16635.54999999902
2025-04-05,413.4499999999498,17048.999999998967
2025-04-07,5006.049999999741,22055.049999998708
2025-04-08,1287.7500000002256,23342.799999998933
2025-04-09,3722.2999999999847,27065.09999999892
2025-04-10,2909.149999999843,29974.249999998763
2025-04-11,1133.0000000000255,31107.24999999879
2025-04-12,110.75000000001273,31217.9999999988
2025-04-14,-3541.54999999977,27676.44999999903
2025-04-15,-1180.8999999999469,26495.549999999083
2025-04-16,1973.2500000001728,28468.799999999253
2025-04-17,-1663.4000000001652,26805.39999999909
2025-04-18,81.0000000000673,26886.399999999157
2025-04-21,-2215.3500000000713,24671.049999999086
2025-04-22,-2947.7499999999545,21723.29999999913
2025-04-23,1262.0999999999876,22985.39999999912
2025-04-24,-51.30000000004111,22934.099999999078
2025-04-25,3240.349999999895,26174.44999999897
2025-04-26,581.1499999999687,26755.599999998944
2025-04-28,609.2499999998126,27364.849999998754
2025-04-29,1653.7499999998854,29018.599999998638
2025-04-30,634.299999999912,29652.89999999855
2025-05-01,1143.3500000001113,30796.24999999866
2025-05-02,-670.9500000000808,30125.29999999858
2025-05-03,-632.8999999999924,29492.39999999859
2025-05-05,4433.000000000007,33925.3999999986
2025-05-06,5574.199999999695,39499.59999999829
2025-05-07,3745.2000000002554,43244.79999999855
2025-05-08,1925.5499999999465,45170.34999999849
2025-05-09,-689.9999999998527,44480.34999999864
2025-05-10,-333.90000000000146,44146.44999999864
2025-05-12,-452.60000000029504,43693.84999999834
2025-05-13,1458.3499999999676,45152.19999999831
2025-05-14,-204.30000000002656,44947.899999998284
2025-05-15,8416.450000000035,53364.34999999832
2025-05-16,1746.5500000000648,55110.89999999838
2025-05-17,-352.10000000000946,54758.79999999837
2025-05-19,1186.499999999949,55945.29999999832
2025-05-20,2980.299999999792,58925.599999998114
2025-05-21,2784.0499999997373,61709.649999997855
2025-05-22,3829.5999999998276,65539.24999999769
2025-05-23,1441.7500000000437,66980.99999999773
2025-05-24,37.600000000000364,67018.59999999774
2025-05-26,24.800000000190266,67043.39999999793
2025-05-27,329.0500000003358,67372.44999999827
2025-05-28,-2268.499999999851,65103.94999999841
2025-05-29,1156.0499999998083,66259.99999999822
2025-05-30,-2089.4499999998643,64170.54999999835
2025-05-31,-629.6999999999844,63540.84999999837
2025-06-02,2748.4499999996297,66289.299999998
2025-06-03,447.10000000018954,66736.39999999819
2025-06-04,632.6499999999778,67369.04999999815
2025-06-05,243.49999999994907,67612.54999999811
2025-06-06,793.8999999999596,68406.44999999806
2025-06-07,559.950000000028,68966.3999999981
2025-06-09,-1394.899999999876,67571.49999999822
2025-06-10,1686.6499999997686,69258.14999999799
2025-06-11,-1985.5500000000702,67272.59999999791
2025-06-12,289.84999999997854,67562.44999999789
`;

    // Parse CSV and set PnL data
    useEffect(() => {
        const parsedData = Papa.parse(csvData, { header: true, skipEmptyLines: true });
        const formattedPnlData = {};

        parsedData.data.forEach(row => {
            const date = new Date(row.date);
            const year = date.getFullYear();
            const month = date.getMonth(); // 0-indexed
            const day = date.getDate();

            // Include data for any year and the current month
            if (month === currentMonth) {
                formattedPnlData[day] = {
                    value: parseFloat(row.daily_pnl),
                    hasData: true
                };
            }
        });

        setPnlData(formattedPnlData);
    }, [currentMonth]); // Remove currentYear from dependencies// Re-run when month or year changes

    // Calculate total PnL for the current month
    const calculateTotalPnL = () => {
        return Object.values(pnlData).reduce((total, day) => total + (day.value || 0), 0);
    };

    // Generate calendar days for the month
    const generateCalendarDays = () => {
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
        const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();

        const daysInPrevMonth = new Date(currentYear, currentMonth, 0).getDate();
        const prevMonthDays = [];
        for (let i = daysInPrevMonth - firstDayOfMonth + 1; i <= daysInPrevMonth; i++) {
            prevMonthDays.push({
                day: i,
                isCurrentMonth: false,
                isPrevMonth: true
            });
        }

        const currentMonthDays = [];
        for (let i = 1; i <= daysInMonth; i++) {
            currentMonthDays.push({
                day: i,
                isCurrentMonth: true,
                pnl: pnlData[i]
            });
        }

        const totalDaysDisplayed = prevMonthDays.length + currentMonthDays.length;
        const remainingCells = totalDaysDisplayed % 7 === 0 ? 0 : 7 - (totalDaysDisplayed % 7);
        const nextMonthDays = [];
        for (let i = 1; i <= remainingCells; i++) {
            nextMonthDays.push({
                day: i,
                isCurrentMonth: false,
                isNextMonth: true
            });
        }

        return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
    };

    const formatPnL = (amount) => {
        if (!amount && amount !== 0) return '';
        const prefix = amount >= 0 ? '$' : '-$';
        const formattedAmount = Math.abs(amount).toFixed(2); // Always show 2 decimal places
        return `${prefix}${formattedAmount}`;
    };

    const getDayStyle = (day) => {
        if (!day.pnl || !day.pnl.hasData) return '';
        return day.pnl.value >= 0 ? 'positive-pnl' : 'negative-pnl';
    };

    const getDateCellClass = (day) => {
        if (!day.isCurrentMonth) return 'date-cell inactive-month';
        return 'date-cell';
    };

    const getDayNumberClass = (day) => {
        if (!day.pnl || !day.pnl.hasData) return 'day-number';
        return day.pnl.value >= 0 ? 'day-number positive-day' : 'day-number negative-day';
    };

    const changeMonth = (direction) => {
        let newMonth = currentMonth + direction;
        if (newMonth < 0) {
            newMonth = 11;
        } else if (newMonth > 11) {
            newMonth = 0;
        }
        setCurrentMonth(newMonth);
    };

    const days = generateCalendarDays();

    return (
        <div className="pnl-calendar-container">
            <div className="month-navigation-container">
                <button
                    className="month-nav-btn"
                    onClick={() => changeMonth(-1)}
                >
                    {months[(currentMonth - 1 + 12) % 12]}
                </button>
                <h2 className="calendar-title">XAUUSD PnL for {months[currentMonth]} {currentYear}</h2>
                <button
                    className="month-nav-btn"
                    onClick={() => changeMonth(1)}
                >
                    {months[(currentMonth + 1) % 12]}
                </button>
            </div>

            <div className="total-pnl">
                Total PnL: <span className={calculateTotalPnL() >= 0 ? 'positive-amount' : 'negative-amount'}>
                    ${calculateTotalPnL().toLocaleString('en-IN', { maximumFractionDigits: 2 })}
                </span>
            </div>

            <div className="calendar-grid">
                <div className="weekday-header">Sun</div>
                <div className="weekday-header">Mon</div>
                <div className="weekday-header">Tue</div>
                <div className="weekday-header">Wed</div>
                <div className="weekday-header">Thu</div>
                <div className="weekday-header">Fri</div>
                <div className="weekday-header">Sat</div>

                {days.map((day, index) => (
                    <div key={index} className={getDateCellClass(day)}>
                        <div className={getDayNumberClass(day)}>
                            {day.day}
                        </div>
                        {day.pnl && day.pnl.hasData && (
                            <div className={`pnl-value ${getDayStyle(day)}`}>
                                {formatPnL(day.pnl.value)}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default XAUUSDPnLCalendar;